import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useEditorActions } from '../../hooks/useEditorActions';
import EditorTitle from '../editor/EditorTitle';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorTitleHeader = () => {
  const {
    props: {
      disableClosingEditorPanel
    },
    isFieldSelectMode
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onConditionSelectCancel,
    onCloseEditor
  } = useEditorActions();
  const button = isFieldSelectMode ? /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: onConditionSelectCancel,
    responsive: false,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filterGroupEditor.cancel"
    })
  }) : /*#__PURE__*/_jsx(UIButton, {
    use: "link",
    onClick: onCloseEditor,
    responsive: false,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.filterGroupEditor.close"
    })
  });
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    minBlockSize: "26px",
    children: [/*#__PURE__*/_jsx(EditorTitle, {}), !disableClosingEditorPanel && button]
  });
};
export default EditorTitleHeader;